import React from 'react';

const TitleHeading = () => (
  <div className='title-heading'>
    <div className='container'>
      <h2 className='title-heading__title'>
        Everyone has the right to clean air. And now with Mila, everyone has the
        opportunity to
        {' '}
        <strong>breathe</strong>
        {' '}
        it.
      </h2>
    </div>
  </div>
);

export default TitleHeading;
